var EVENT_SOURCES;
(function (EVENT_SOURCES) {
    EVENT_SOURCES["KEYBOARD"] = "keyboard";
    EVENT_SOURCES["MOUSE"] = "mouse";
    EVENT_SOURCES["MOBILE"] = "mobile";
})(EVENT_SOURCES || (EVENT_SOURCES = {}));
let lastEventSource = null;
const updateLastEventSourceOnEvent = (eventName, nextEventSource) => {
    document.addEventListener(eventName, () => (lastEventSource = nextEventSource));
};
if (typeof document !== 'undefined') {
    updateLastEventSourceOnEvent('keydown', EVENT_SOURCES.KEYBOARD);
    updateLastEventSourceOnEvent('keyup', EVENT_SOURCES.KEYBOARD);
    // Note: sometimes, NVDA can emulate mousedown events and focusable section will be unread
    updateLastEventSourceOnEvent('mousedown', EVENT_SOURCES.MOUSE);
    updateLastEventSourceOnEvent('mouseup', EVENT_SOURCES.MOUSE);
    updateLastEventSourceOnEvent('touchstart', EVENT_SOURCES.MOBILE);
    updateLastEventSourceOnEvent('touchend', EVENT_SOURCES.MOBILE);
}
export function isNavigationFromKeyboard() {
    return lastEventSource === EVENT_SOURCES.KEYBOARD;
}
export function focus(element) {
    if (typeof document === 'undefined') {
        return;
    }
    if (!document.hasFocus()) {
        return;
    }
    const isEventSourcePresent = Boolean(lastEventSource);
    if (!element || (isEventSourcePresent && !isNavigationFromKeyboard())) {
        return;
    }
    _focus(element);
}
function _focus(element) {
    const previousTabIndex = element.getAttribute('tabindex');
    function removeFocusSource() {
        element.removeEventListener('blur', removeFocusSource);
        element.removeAttribute('focused-with-source');
        if (previousTabIndex) {
            element.setAttribute('tabindex', previousTabIndex);
        }
        else {
            element.removeAttribute('tabindex');
        }
    }
    element.setAttribute('tabindex', '0');
    if (lastEventSource) {
        element.setAttribute('focused-with-source', lastEventSource);
    }
    element.addEventListener('blur', removeFocusSource);
    if (element.getAttribute('aria-label')) {
        element.focus();
        return;
    }
    // Hack for NVDA reading block content
    // In case, you will touch this, please, test reading of:
    //   chanel info (at modal, without aria-label)
    //   video info (without aria-label)
    //   search result (without aria-label)
    element.setAttribute('aria-live', 'polite');
    element.setAttribute('aria-relevant', 'text');
    element.setAttribute('aria-atomic', 'true');
    const elWrapper = document.createElement('div');
    const el = document.createElement('span');
    elWrapper.style.position = 'relative';
    elWrapper.style.overflow = 'hidden';
    el.style.position = 'absolute';
    el.style.right = '-10000%';
    el.innerHTML = '&nbsp;';
    setTimeout(() => {
        elWrapper.appendChild(el);
        element.appendChild(elWrapper);
        setTimeout(() => {
            element.removeAttribute('aria-live');
            element.removeAttribute('aria-relevant');
            element.removeAttribute('aria-atomic');
        }, 10);
    }, 10);
    element.focus();
}
//# sourceMappingURL=accessibility-focus.js.map